import React, { memo } from 'react';
import {
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  PieSeries,
  AccumulationDataLabel,
  AccumulationChartComponent,
  AccumulationLegend,
  AccumulationTooltip,
} from '@syncfusion/ej2-react-charts';
import PropTypes from 'prop-types';

const DonutChartComponent = ({ chartResult, chartPalette, jobId }) => {
  const { queryConstruct } = chartResult?.query || {};
  const qcChart = queryConstruct.chart;

  return (
    <AccumulationChartComponent
      id={`chart-${jobId}`}
      width="100%"
      height="100%"
      enableSmartLabels={true}
      enableBorderOnMouseMove={false}
      style={{ textAlign: 'center' }}
      legendSettings={
        qcChart?.format.legend
          ? {
              visible: true,
              enableHighlight: true,
              textWrap: 'Wrap',
              position: 'Bottom',
              alignment: 'Near',
              containerPadding: { top: 20 },
              itemPadding: 0,
              padding: 10,
            }
          : {}
      }
      tooltip={{ enable: true }}
      palettes={chartPalette}>
      <Inject services={[PieSeries, AccumulationDataLabel, AccumulationLegend, AccumulationTooltip]} />
      <AccumulationSeriesCollectionDirective>
        {chartResult?.queryResult?.map((series, i) => {
          const axisNames = Object.keys(series.metadata);
          const xName = axisNames?.length ? axisNames[0] : 'x';
          const yName = axisNames?.length ? axisNames[1] : 'y';

          const seriesData = series.data.map(ele => {
            return {
              x: ele.x,
              y: ele.y,
              label: ele.y,
            };
          });

          return (
            <AccumulationSeriesDirective
              key={i}
              dataSource={seriesData}
              xName={xName}
              yName={yName}
              yAxisName={yName === 'y1' ? 'yAxis2' : null}
              innerRadius="40%"
              startAngle={0}
              endAngle={360}
              radius="80%"
              explode={true}
              explodeOffset="10%"
              explodeIndex={0}
              dataLabel={{
                visible: true,
                position: 'Outside',
                name: 'label',
                font: {
                  fontFamily: 'Noto Sans',
                },
                connectorStyle: {
                  length: '20px',
                  width: 2,
                },
              }}
            />
          );
        })}
      </AccumulationSeriesCollectionDirective>
    </AccumulationChartComponent>
  );
};

DonutChartComponent.propTypes = {
  data: PropTypes.object,
  chartPalette: PropTypes.array.isRequired,
  generateAxis: PropTypes.func.isRequired,
  chartResult: PropTypes.object,
  jobId: PropTypes.string.isRequired,
  chartType: PropTypes.string.isRequired,
};

export default memo(DonutChartComponent);
